export default "__VITE_ASSET__BXapW2jK__"